import {
  Button,
  FormLabel,
  Select,
  Spinner,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import Toast from "../Components/Toast";
import { TsdsInput } from "../Components/TsdsInput";
import { useAppDispatch } from "../Hooks/useAppDispatch";
import { useAppSelector } from "../Hooks/useAppSelector";
import {
  getRole,
  getToken,
  register,
  selectAdminFetching,
} from "../Redux/AdminSlice";

function RegisterScreen() {
  const dispatch = useAppDispatch();
  const fetching = useAppSelector<boolean>(selectAdminFetching);
  const token = useAppSelector<string>(getToken);
  const role = useAppSelector<string>(getRole);
  const navigate = useNavigate();

  //   useEffect(() => {
  //     if (token.length === 0) navigate('/')
  //     else if (role !== 'admin') navigate('/addItem')
  //   }, [token])

  const formik = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      user_name: "",
      mobile_num: "",
      password: "",
      email: "",
      role: "product",
    },
    onSubmit: (values) => {
      dispatch(register(values));
    },
  });

  return (
    <div className="register">
      <Toast />
      <div
        className="img"
        style={{
          position: "fixed",
          opacity: "0.5",
          top: "50%",
          left: "50%",
          marginTop: "-100px",
          marginLeft: "-100px",
        }}
      >
        <img src="logo.png" />
      </div>
      <div
        className="form"
        style={{ maxWidth: "300px", margin: "auto", marginTop: "30px" }}
      >
        <form onSubmit={formik.handleSubmit}>
          <Text fontSize="xl" fontWeight="bold" mb={3}>
            Admin Register
          </Text>
          <VStack>
            <TsdsInput
              label="First Name"
              name="first_name"
              type="text"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.first_name}
              isRequired
            />
            <TsdsInput
              label="Last Name"
              name="last_name"
              type="text"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.last_name}
            />
            <TsdsInput
              label="Mobile Number"
              name="mobile_num"
              type="text"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.mobile_num}
              isRequired
            />
            <TsdsInput
              label="Username"
              name="user_name"
              type="text"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.user_name}
              isRequired
            />
            <TsdsInput
              label="Password"
              name="password"
              type="password"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.password}
              isRequired
            />
            <TsdsInput
              label="Email"
              name="email"
              type="text"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.email}
            />
            <FormLabel mb={"1px"} fontWeight="bold" color="grey">
              Role
            </FormLabel>
            <Select
              name="role"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.role}
              _active={{ border: "2px solid", borderColor: "green4" }}
              _focus={{ border: "2px solid", borderColor: "green4" }}
              _hover={{ border: "2px solid", borderColor: "green4" }}
            >
              <option value="admin">Admin</option>
              <option value="product">Product</option>
              <option value="fots">FOTS</option>
              <option value="data">Data</option>
              <option value="sales">Sales</option>
            </Select>
            <Button type="submit">
              Register {fetching ? <Spinner size="sm" ml={2} /> : <></>}
            </Button>
          </VStack>
        </form>
      </div>
    </div>
  );
}

export default RegisterScreen;
